import { handleVersionMismatch } from 'actions/versionSync';
import { VersionMismatch } from 'services/BaseService';
import * as StoryletActionTypes from '../../actiontypes/storylet';
import StoryletService from 'services/StoryletService';
import IStoryletService, { IAddNewContactData, IAddNewContactResponseData } from 'types/storylet/service';

/** ----------------------------------------------------------------------------
 * ADD NEW CONTACT
 -----------------------------------------------------------------------------*/

export default addNewContact(new StoryletService());

export function addNewContact(service: IStoryletService) {
  return (contactData: IAddNewContactData) => async (dispatch: Function) => {
    dispatch(addNewContactRequest());
    try {
      const { data } = await service.addNewContact(contactData);
      dispatch(addNewContactSuccess(data));
      return data;
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
      }
      return dispatch(addNewContactFailure());
    }
  };
}

const addNewContactRequest = () => ({
  type: StoryletActionTypes.ADD_NEW_CONTACT_REQUESTED,
  isSaving: true,
});

const addNewContactSuccess = (data: IAddNewContactResponseData) => ({
  type: StoryletActionTypes.ADD_NEW_CONTACT_SUCCESS,
  payload: {
    addedFriendId: data.addedFriendId,
    eligibleFriends: data.eligibleFriends,
    message: data.message,
  },
});
const addNewContactFailure = (/* error */) => ({
  type: StoryletActionTypes.ADD_NEW_CONTACT_FAILURE,
  isSaving: false,
  error: true, // ,
  // status: error.response && error.response.status
});